<template id="trafficData">
  <div style="height:100%;overflow-y: auto;">
    <div ref="container" :style="{'height': height,'width':width}"></div>
  </div>
  
</template>
<script type="text/javascript" src="https://cdn.jsdelivr.net/npm/echarts@5.3.2/dist/echarts.min.js"></script>
<script>
import * as echarts from 'echarts';
import {IotExtranetTrafficServiceProxy} from "@/service-proxies/app-v2/iotmodel-storage.service-proxies";
const ecsp = new IotExtranetTrafficServiceProxy()

export default {
  name: "TrafficData",
  data() {
    return {
      send: 0.0,
      rec: 0.0,
      sends: [],
      recs: [],
      dataTimes: [],
      myChart:null,
    }
  },
  props: {
    gatewayCode: {},
    gatewayCodeProps:{
      type:String,
      default:''
    },
    height:{
      type: String,
      default: '400px'
    },
    width:{
      type: String,
      default: '100%'
    }

  },
  mounted() {
    this.init()
  },
  beforeDestroy(){
    if(this.myChart){
      this.myChart.dispose()
      this.myChart = undefined
    }
  },
  methods: {
    init(){
      this.getTrafficData()
      this.$nextTick(() => this.initEcharts())
    },
    initEcharts() {
      this.myChart = echarts.init(this.$refs.container);
      this.myChart.setOption({
        title: {
          left: 'center',
          text: '流量统计(Mbps)',

        },
        graphic: {
          type: 'text',
          right: '60px',
          top: '5px',
          style: {
            text: '当前：' + this.rec + ' (入) ' + this.send + ' (出)',
            // top:"40%",
            textAlign: 'right',
            fontSize: 16,
            fontWeight: 500
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            animation: false
          }
        },
        // toolbox: {
        //   show: true,
        //   feature: {
        //     dataZoom: {
        //       yAxisIndex: 'none'
        //     },
        //     dataView: { readOnly: false },
        //     magicType: { type: ['line', 'bar'] },
        //     restore: {},
        //     saveAsImage: {}
        //   }
        // },
        legend: {
          left: '40px'
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          symbolSize: 10,
          data: this.dataTimes
        },
        yAxis: {
          // min:'dataMin', //取最小值为最小刻度
          max: 'dataMax', //取最大值为最大刻度
          min: function(value) {//取最小值向下取整为最小刻度
            return Math.floor(value.min)
          },
          // max: function(value) {//取最大值向上取整为最大刻度
          //   return  Math.ceil(value.max)
          // },

          type: 'value',
          axisLabel: {
            formatter: '{value}'
          }
        },
        series: [
          {
            name: '发送流量',
            data: this.sends,
            type: 'line',
            smooth: true
          },
          {
            name: '接收流量',
            data: this.recs,
            type: 'line',
            smooth: true
          }
        ]
      })
    },

    getTrafficData() {
      if (this.gatewayCode) {
        ecsp.getTrafficData(this.gatewayCode).then((res) => {
          if (res){
            this.recs = res.recs ? res.recs : []
            this.sends = res.sends ? res.sends : []
            this.rec = res.rec ? res.rec : 0.0
            this.send = res.send ? res.send : 0.0
            this.dataTimes = res.dataTimes ? res.dataTimes : []
            this.setOption()
          }
        })
      }
    },

    setOption(){
      this.myChart.setOption({
        graphic: {
          style: {
            text: '当前：' + this.rec + ' (入) ' + this.send + ' (出)',
          }
        },
        xAxis: {
          data: this.dataTimes
        },
        series: [
          {
            data: this.sends,
          },
          {
            data: this.recs,
          }
        ]
      })
    }
  },
  watch:{

  }
}
</script>

<style scoped>

</style>